import rechargeApis from '../../service/apis/recharge.js'

import { download } from '../../plugins/helper'

import { Message } from 'element-ui'

const GET_GROUPACCOUNT_INFO = 'GET_GROUPACCOUNT_INFO'
const GET_RECHARGE_RECORDS = 'GET_RECHARGE_RECORDS'

export default {
  namespaced: true,
  state: {
    groupAccountInfo: {},
    rechargeRecords: []
  },
  mutations: {
    [GET_GROUPACCOUNT_INFO] (state, param) {
      state.groupAccountInfo = param.data
    },
    [GET_RECHARGE_RECORDS] (state, param) {
      state.rechargeRecords = param.data
    }
  },
  actions: {
    getgroupAccountInfo (context) {
      rechargeApis.getGroupAccountInfo().then(function (response) {
        context.commit(GET_GROUPACCOUNT_INFO, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    async downloadTemplate ({ commit, state }, data) {
      try {
        download('/eos/coupon/fund/downloadTemplate', data)
      } catch (e) {
        console.log(e)
        Message.error('下载失败')
      } finally {
      }
    },
    getRechargeRecords (context, params) {
      rechargeApis.getRechargeRecords(params).then(function (response) {
        context.commit(GET_RECHARGE_RECORDS, response)
      }).catch(function (error) {
        console.log('err>>>>>', error)
      })
    }
  }
}
